import { useDispatch } from 'react-redux';
import { setNpsConsentAnswer } from '../../../../ducks/global';
import { NPS_CONSENT_ANSWER } from '../../../../enums';
import { putNpsEligibilityClaim } from '../../../../ducks/coreApi';

const useConnect = () => {
  const dispatch = useDispatch();
  return {
    onYes: () => {
      dispatch(setNpsConsentAnswer(NPS_CONSENT_ANSWER.YES));
      dispatch(putNpsEligibilityClaim());
    },
    onNo: () => {
      dispatch(setNpsConsentAnswer(NPS_CONSENT_ANSWER.NO));
      dispatch(putNpsEligibilityClaim());
    },
  };
};

export default useConnect;
